import axiosInstanceBuilder from "../config/axios/axiosInstanceBuilder";
import { useFetch } from "../config/axios/useFetch";
import axios from "axios";
import { useSelector } from "react-redux";

const baseUrl = process.env.REACT_APP_API_DEV_URL;

export const useAuthenticatedUserRole = (callAfterMount = false) => {
  const ubaToken = useSelector((state) => state.ubaToken.ubaToken);

  const createAxiosPromise = () => {
    if (ubaToken?.tokenFromUrl) {
      return axios.get(`${baseUrl}/uba/users/role`, {
        params: { tk: ubaToken.tokenFromUrl },
      });
    } else {
      return axiosInstanceBuilder(baseUrl).get("/users/role");
    }
  };

  const { data, isPending, error, fetchApi } = useFetch(
    createAxiosPromise,
    callAfterMount
  );

  const getAuthenticatedUserRole = async () => {
    const response = await fetchApi();
    const { data, ...rest } = response;
    return { userRole: data.user_role, ...rest };
  };

  return {
    userRole: data,
    isLoading: isPending,
    error,
    getAuthenticatedUserRole,
  };
};
